export const greyMapStyle = {
    styles: [
      {
        "featureType": "all",
        "elementType": "labels.text.fill",
        "stylers": [{"saturation": 36}, {"color": "#333333"}, {"lightness": 40}]
      },
      {
        "featureType": "all",
        "elementType": "labels.text.stroke",
        "stylers": [{"visibility": "on"}, {"color": "#ffffff"}, {"lightness": 16}]
      },
      {
        "featureType": "all",
        "elementType": "labels.icon",
        "stylers": [{"visibility": "on"}, {"saturation": -100}, {"lightness": 40}]
      },
      {
        "featureType": "administrative",
        "elementType": "geometry.fill",
        "stylers": [{"color": "#fefefe"}, {"lightness": 20}]
      },
      {
        "featureType": "administrative",
        "elementType": "geometry.stroke",
        "stylers": [{"color": "#fefefe"}, {"lightness": 17}, {"weight": 1.2}]
      },
      {
        "featureType": "landscape",
        "elementType": "geometry",
        "stylers": [{"color": "#f5f5f5"}, {"lightness": 20}]
      },
      {
        "featureType": "poi",
        "elementType": "geometry",
        "stylers": [{"color": "#e6e6e6"}, {"lightness": 21}]
      },
      {
        "featureType": "poi.park",
        "elementType": "geometry",
        "stylers": [{"color": "#e6e6e6"}, {"lightness": 21}]
      },
      {
        "featureType": "poi.business",
        "elementType": "geometry",
        "stylers": [{"color": "#e6e6e6"}, {"lightness": 21}]
      },
      {
        "featureType": "poi.attraction",
        "elementType": "geometry",
        "stylers": [{"color": "#e6e6e6"}, {"lightness": 21}]
      },
      {
        "featureType": "road.highway",
        "elementType": "geometry.fill",
        "stylers": [{"color": "#ffffff"}, {"lightness": 17}]
      },
      {
        "featureType": "road.highway",
        "elementType": "geometry.stroke",
        "stylers": [{"color": "#ffffff"}, {"lightness": 29}, {"weight": 0.2}]
      },
      {
        "featureType": "road.arterial",
        "elementType": "geometry",
        "stylers": [{"color": "#ffffff"}, {"lightness": 18}]
      },
      {
        "featureType": "road.local",
        "elementType": "geometry",
        "stylers": [{"color": "#ffffff"}, {"lightness": 16}]
      },
      {
        "featureType": "transit",
        "elementType": "geometry",
        "stylers": [{"color": "#f2f2f2"}, {"lightness": 19}]
      },
      {
        "featureType": "water",
        "elementType": "geometry",
        "stylers": [{"color": "#b1ddf0"}, {"lightness": 17}]
      },
      {
        "featureType": "poi",
        "elementType": "labels",
        "stylers": [{"visibility": "on"}, {"lightness": 20}, {"saturation": -100}]
      },
      {
        "featureType": "poi.park",
        "elementType": "labels",
        "stylers": [{"visibility": "on"}, {"lightness": 20}, {"saturation": -100}]
      },
      {
        "featureType": "poi.business",
        "elementType": "labels",
        "stylers": [{"visibility": "on"}, {"lightness": 20}, {"saturation": -100}]
      },
      {
        "featureType": "poi.attraction",
        "elementType": "labels",
        "stylers": [{"visibility": "on"}, {"lightness": 20}, {"saturation": -100}]
      }
    ],
    disableDefaultUI: true,
    zoomControl: true,
    mapTypeControl: false,
    streetViewControl: false,
    fullscreenControl: false
};